import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  deepSetObject, digObject, toggleArray,
} from '@domain-group/javascript-utils'

import {
  Box,
  Button,
  Checkbox,
  ListItem,
  ModalContext,
  SidebarModal,
} from '@domain-group/suit-theme'

import useOrderItemTaskTypes from '@hooks/useOrderItemTaskTypes'
import useServiceProduct, { useServiceProductForm } from '@hooks/useServiceProduct'

const handleTasks = (productForm, title) => {
  const {
    entityState: {
      options,
      options: {
        tasks,
      },
    },
    setEntityState,
  } = productForm

  const { required_tasks } = tasks || {}

  const updatedTasks = toggleArray(required_tasks, title)
  const updatedOptions = deepSetObject(options, 'tasks.required_tasks', updatedTasks)

  setEntityState({ options: updatedOptions })
}

const EditProductTaskSettingsModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updateServiceProduct } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { serviceProduct } = digObject(modalData, modalKey, {})

  const productPayload = useServiceProduct(serviceProduct)
  const {
    callbacks: {
      updateServiceProduct: updateFn,
    },
    updating,
  } = productPayload

  const productForm = useServiceProductForm(serviceProduct)
  const {
    entityState,
    entityState: {
      options,
    },
  } = productForm

  const requiredTasks = digObject(options, 'tasks.required_tasks', [])

  const { filteredOrderItemTaskTypes } = useOrderItemTaskTypes({
    performHttpRequests: true,
  })

  const editTaskSettingsPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Task Settings Updated',
  }

  return (
    <SidebarModal
      callbacks={callbacks}
      modalKey={modalKey}
      showModal={showModal}
      size="small"
    >
      <SidebarModal.Header
        callbacks={callbacks}
        title="Task"
        titleSecondLine="Settings"
      />

      <SidebarModal.Content>
        {filteredOrderItemTaskTypes.map((taskType) => {
          const { id, title } = taskType

          return (
            <ListItem.WithCheckbox
              boxProps={{ border: 'none' }}
              checkbox={(
                <Checkbox
                  checked={requiredTasks.includes(title)}
                  onClick={() => handleTasks(productForm, title)}
                />
              )}
              disableHover
              key={id}
            >
              <Box color="bodyFontColor" fontSize="small">
                {title}
              </Box>
            </ListItem.WithCheckbox>
          )
        })}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateServiceProduct(editTaskSettingsPayload)}
          size="large"
        >
          Save Tasks
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

EditProductTaskSettingsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

EditProductTaskSettingsModal.defaultProps = {
  modalKey: 'EditProductTaskSettingsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <EditProductTaskSettingsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
